import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import './CarouselNavigation.css';

interface CarouselNavigationProps {
  direction: 'left' | 'right';
  onClick: () => void;
  disabled?: boolean;
  ariaLabel?: string;
}

/**
 * CarouselNavigation - Arrow button for carousel navigation
 * Features gradient fade effect and disabled state
 */
export const CarouselNavigation: React.FC<CarouselNavigationProps> = ({
  direction,
  onClick,
  disabled = false,
  ariaLabel,
}) => {
  const icon = direction === 'left' ? faChevronLeft : faChevronRight;
  const defaultAriaLabel =
    direction === 'left' ? 'Previous activities' : 'Next activities';

  return (
    <button
      className={`carousel-nav carousel-nav--${direction} ${
        disabled ? 'carousel-nav--disabled' : ''
      }`}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel || defaultAriaLabel}
      type="button"
    >
      <div className="carousel-nav__gradient" />
      <div className="carousel-nav__button">
        <FontAwesomeIcon icon={icon} />
      </div>
    </button>
  );
};

export default CarouselNavigation;
